import '../../CSS/private/Form.css';
import FormDetails from './FormDetails';

function FormButton(props)
{
  const accentColour = props.accentColour;
  const onClick = props.onClick;

  const formDetails = <FormDetails title={props.title} description={props.description} />

  const style = props.bordered? (
    {
      ...{backgroundColor: '#00000000'},
      ...{border: ('1px solid ' + accentColour)},
      ...{color: accentColour},
      ...{marginBottom: (props.gap? '10px' : '0')}
    }
  ) : (
    {
      ...{backgroundColor: accentColour}
    }
  )

  return (
    <div className='slp-form'>
      {formDetails}
      <button style={style} className='slp-form-button' onClick={onClick}>
        {props.label}
      </button>
    </div>
  )
}

export default FormButton;